import BookShow from "components/shared/book/show";
import Loader from "components/shared/loader";
import { dateTimeToView } from "helpers/date";
import { viewContainer } from "helpers/redux";
import React from "react";

class ShowUserLog extends BookShow {
    requestId = 0;

    componentWillUnmount() {
        this.requestId += 1;
    }

    getItem = ({ source, id, date }) => {
        const requestId = ++this.requestId;
        const defParams = { isLoading: false, isValid: true, shouldUpdate: false };
        const config = {
            name: "infoModal",
            windowMod: "wide",
            title: "Информация о запросе",
            body: this.loadingModalBody(),
            onCloseAction: this.props.back,
        };

        this.props.modal(config);
        source
            .getItem({ id, date })
            .then((data) => {
                if (requestId !== this.requestId) {
                    return;
                }
                if (!data) {
                    this.showLoadingError();
                    return;
                }
                this.setState({ data, initial: data, ...defParams });
                this.props.updateModal({ body: this.logModalBody(data) });
            })
            .catch(() => {
                if (requestId === this.requestId) {
                    this.showLoadingError();
                }
            });
    };

    loadingModalBody = () => {
        return (
            <div
                aria-label="Загрузка информации о запросе"
                aria-live="polite"
                className="modal--vh-50 position-relative"
                role="status"
            >
                <Loader wrapCname="content-center d-flex justify-content-center h-100" />
            </div>
        );
    };

    showLoadingError = () => {
        this.setState({ isLoading: false, isValid: false });
        this.props.updateModal({
            body: (
                <div className="modal--vh-50 d-flex align-items-center justify-content-center text-muted">
                    Не удалось загрузить информацию о запросе.
                </div>
            ),
        });
    };

    parseJson = (text) => {
        if (!text) {
            return text;
        }
        let parsed = true;
        while (parsed) {
            try {
                text = JSON.parse(text);
            } catch (_e) {
                parsed = false;
            }
        }
        return text;
    };

    logModalBody = (original) => {
        if (!original) {
            return null;
        }
        const requestBodyJson = this.parseJson(original.requestBody);
        const responseBodyJson = this.parseJson(original.responseBody);
        return (
            <div className="h-100">
                <div className="row form-group">
                    <div className="col-md-2">
                        <strong>Дата</strong>
                    </div>
                    <div className="col-md-10">{dateTimeToView(original.date, "DD.MM.YYYY HH:mm:ss (Z)")}</div>
                </div>
                <div className="row form-group">
                    <div className="col-md-2">
                        <strong>Пользователь</strong>
                    </div>
                    <div className="col-md-10">{original.userName}</div>
                </div>
                <div className="row form-group">
                    <div className="col-md-2">
                        <strong>Статус</strong>
                    </div>
                    <div className="col-md-10">{original.statusCode}</div>
                </div>
                <div className="row form-group">
                    <div className="col-md-2">
                        <strong>Метод запроса</strong>
                    </div>
                    <div className="col-md-10">{original.httpMethod}</div>
                </div>
                <div className="row form-group">
                    <div className="col-md-2">
                        <strong>Url запроса</strong>
                    </div>
                    <div className="col-md-9 log-modal__text">{original.requestUrl}</div>
                </div>
                <div className="row form-group">
                    <div className="col-md-2">
                        <strong>Исключение</strong>
                    </div>
                    <div className="col-md-10 log-modal__text">{original.exception}</div>
                </div>
                <div className="row form-group">
                    <div className="col-md-2">
                        <strong>TraceId / MessageId</strong>
                    </div>
                    <div className="col-md-10 log-modal__text">
                        {original.traceId} / {original.messageId}
                    </div>
                </div>
                <div className="row form-group">
                    <div className="col-md-2">
                        <strong>IP адрес</strong>
                    </div>
                    <div className="col-md-10 log-modal__text">{original.ipAddress}</div>
                </div>
                <div className="row form-group">
                    <div className="col-md-2">
                        <strong>Длительность (мс)</strong>
                    </div>
                    <div className="col-md-10 log-modal__text">{original.duration}</div>
                </div>
                <div className="row form-group">
                    <div className="col-md-12">
                        <strong>Тело запроса</strong>
                    </div>
                    <div className="col-md-12 log-modal__text">
                        {requestBodyJson && JSON.stringify(requestBodyJson, null, 4)}
                    </div>
                </div>
                <div className="row form-group">
                    <div className="col-md-12">
                        <strong>Тело ответа</strong>
                    </div>
                    <div className="col-md-12 log-modal__text">
                        {responseBodyJson && JSON.stringify(responseBodyJson, null, 4)}
                    </div>
                </div>
            </div>
        );
    };

    render() {
        return null;
    }
}

export default viewContainer(ShowUserLog, "userLogs");
